﻿window.dxToastCourant = null;
window.mNotify = function (html, code, tempo, funcClick) {
    if (dxToastCourant) {
        dxToastCourant.hide();
        dxToastCourant = null;
    }
    if (typeof code == "undefined") code = "info"
    if (typeof tempo == "undefined") tempo = 6
    code = code[0].toUpperCase() + code.substring(1);
    var toastContentElement
    dxToastCourant = $("<div/>").appendTo("body").dxToast({
        closeOnClick: false,
        hideOnOutsideClick: true,
        contentTemplate: function (contentElement) {
            contentElement.css("padding", "8px");
            contentElement.html("<div>" + html + "</div>")
            toastContentElement = contentElement;
            contentElement.on("mouseenter", function () {
                toastContentElement.mouseIsIn = true;
            })
            contentElement.on("mouseleave", function () {
                toastContentElement.mouseIsIn = false;
                if (toastContentElement.isTryHidding && dxToastCourant) dxToastCourant.hide();
            })
            toastContentElement.mouseIsIn = false;
            toastContentElement.isTryHidding = false;
            toastContentElement.on("click", function () {
                toastContentElement.mouseIsIn = false;
                if (dxToastCourant) dxToastCourant.hide();
            })
        },
        displayTime: tempo,
        message: "",
        visible: true,
        type: code,
        position: { my: "bottom", at: "bottom", offset: '0 -' + (((typeof heightBarreTache == "undefined") ? 0 : heightBarreTache) + 25) },
        onHiding: function (e) {
            if (toastContentElement.mouseIsIn) {
                e.cancel = true;
                toastContentElement.isTryHidding = true;
            }
        },
        onHidden: function (e) {
            e.component.element().remove()
            dxToastCourant = null;
        },
        onContentReady: function (e) {
            if (typeof funcClick != 'undefined' && funcClick) {
                e.component.content().css("cursor", "pointer")
                e.component.content().addClass("state-hover")
                e.component.content().on("click", function () {
                    funcClick();
                });
            }
        }
    }).dxToast("instance");
}

window.date_debut_deploiement = null;
window.popAlertDeploiement = null;
window.mShowAlertDeploiement = function (temps_deploiement, bddCtrl) {
    if (!popAlertDeploiement) {
        date_debut_deploiement = new Date();
        date_debut_deploiement = date_debut_deploiement.addSecondes(parseInt(temps_deploiement - 10));
        var nbSecondTotal = diffdate(new Date(), date_debut_deploiement, "s");
        var $DivTime = null;
        var contentForBackground = null;
        popAlertDeploiement = notify.mShow({
            bddCtrl: bddCtrl,
            showCloseButton: false,
            titre: 'Déploiement',
            tempoSeconde: diffdate(new Date(), date_debut_deploiement, "s"),
            img: "<i class='fas fa-broadcast-tower'/>",
            son: "attention",
            message: function (contentElement, popup) {
                contentForBackground = contentElement
                //contentForBackground1 = $(popup.element().find(".dx-popup-title").css("background-color", ""))
                //contentForBackground2 = $(popup.element().find(".dx-popup-content").css("background-color", ""))
                var $Table = $("<table/>").appendTo(contentElement);
                var $Tr = $("<tr/>").appendTo($Table)
                //var $Td = $("<td style='width:1px;padding-right:5px'><img src='" + IMG_warning + "'/></td>").appendTo($Tr)
                var $Td = $("<td style='width:100%'>Une mise à jour de votre application va être déployée. Vous allez être deconnecté dans<br/></td>").appendTo($Tr)
                $DivTime = $("<div style='font-size:28px;font-weight:bold'/>").appendTo($Td)
                $("<span>Veuillez sauvegarder votre travail.<br/>Le déploiement dure environ 2 minutes.</span>").appendTo($Td)
                mDecompte();
            }
        })
        //var onhidden = popAlertDeploiement.option("onHidden")
        //popAlertDeploiement.option("onHidden", function (e) {
        //    if (typeof onhidden != 'undefined') onhidden(e);
        //    popAlertDeploiement = null;
        //})

        function mDecompte() {
            var secRestante = diffdate(new Date(), date_debut_deploiement, "s");
            var minutes = Math.floor(secRestante / 60);
            var secondes = (secRestante - minutes * 60);
            $DivTime.text("00:" + ((minutes < 10) ? "0" : "") + minutes + ":" + ((secondes < 10) ? "0" : "") + secondes + "")
            contentForBackground.css("color", "rgba(255, 0, 0, " + (1 - (secRestante / nbSecondTotal) / 2) + ")");
            //contentForBackground2.css("background-color", "rgba(255, 0, 0, " + (1 - (secRestante / nbSecondTotal) / 2) + ")");
            if (secRestante <= 0) {
                forcerFermetureNavigateur = true;
                mRedirectOnLogin("livraison")

                //function mGereReconnexion() {
                //    mUrlExists(document.URLRacine, function (ok) {
                //        if (ok) { mRedirectOnLogin() }
                //        else { window.setTimeout(function () { mGereReconnexion(); }, 5000) }
                //    })
                //}
                //window.setTimeout(function () { mGereReconnexion(); }, 30000)
            }
            else { window.setTimeout(function () { mDecompte(); }, 1000) }
        }
    } else {
        //popAlertDeploiement.bringToFront();
    }
}

window.$AUDIOAttention = null
window.$AUDIOEmail = null
window.$AUDIOInfo = null
window.$AUDIORappel = null
window.$AUDIOPop = null
window.$AUDIOTut = null
window.$AUDIOGuitare = null
window.$AUDIOFlute = null
window.$AUDIOClickPhoto = null
$(document).ready(function () {
    //$AUDIOAttention = $('<audio src="' + parametre.urldispatch + '/son/attention.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOEmail = $('<audio src="' + parametre.urldispatch + '/son/email.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOInfo = $('<audio src="' + parametre.urldispatch + '/son/information.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIORappel = $('<audio src="' + parametre.urldispatch + '/son/rappel.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOPop = $('<audio src="' + parametre.urldispatch + '/son/pop.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOTut = $('<audio src="' + parametre.urldispatch + '/son/tut.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOGuitare = $('<audio src="' + parametre.urldispatch + '/son/guitare.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOFlute = $('<audio src="' + parametre.urldispatch + '/son/flute.mp3?v=' + parametre.version + '"/>').appendTo("body");
    //$AUDIOClickPhoto = $('<audio src="' + parametre.urldispatch + '/son/click_photo.mp3?v=' + parametre.version + '"/>').appendTo("body");

    $AUDIOAttention = new Audio(parametre.urldispatch + '/son/attention.mp3?v=' + parametre.version);
    $AUDIOEmail = new Audio(parametre.urldispatch + '/son/email.mp3?v=' + parametre.version);
    $AUDIOInfo = new Audio(parametre.urldispatch + '/son/information.mp3?v=' + parametre.version);
    $AUDIORappel = new Audio(parametre.urldispatch + '/son/rappel.mp3?v=' + parametre.version);
    $AUDIOPop = new Audio(parametre.urldispatch + '/son/pop.mp3?v=' + parametre.version);
    $AUDIOTut = new Audio(parametre.urldispatch + '/son/tut.mp3?v=' + parametre.version);
    $AUDIOGuitare = new Audio(parametre.urldispatch + '/son/guitare.mp3?v=' + parametre.version);
    $AUDIOFlute = new Audio(parametre.urldispatch + '/son/flute.mp3?v=' + parametre.version);
    $AUDIOClickPhoto = new Audio(parametre.urldispatch + '/son/click_photo.mp3?v=' + parametre.version);
})

window.cDxNotify = function () {

    var lstPopup = [];
    var indx = 0;
    this.mShow = function (option) {
        return messagePopup.mShow(option)
        return

        ////if (!$AUDIOAttention) {
        ////    $AUDIOAttention = $('<audio src="' + parametre.urldispatch + '/son/attention.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOEmail = $('<audio src="' + parametre.urldispatch + '/son/email.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOInfo = $('<audio src="' + parametre.urldispatch + '/son/information.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIORappel = $('<audio src="' + parametre.urldispatch + '/son/rappel.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOPop = $('<audio src="' + parametre.urldispatch + '/son/pop.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOTut = $('<audio src="' + parametre.urldispatch + '/son/tut.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOGuitare = $('<audio src="' + parametre.urldispatch + '/son/guitare.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////    $AUDIOFlute = $('<audio src="' + parametre.urldispatch + '/son/flute.mp3?v=' + parametre.version + '"/>').appendTo("body");
        ////}

        //var popup = $('<div/>').appendTo(((typeof $DivGeneral != 'undefined') ? $DivGeneral : "body")).dxPopup({
        //    width: ((typeof option.width == 'undefined') ? 400 : option.width),
        //    height: 100,
        //    showTitle: ((typeof option.showTitle != 'undefined') ? option.showTitle : true),
        //    title: option.titre,
        //    resizeEnabled: false,
        //    showCloseButton: ((typeof option.showCloseButton == 'undefined') ? ttrue : option.showCloseButton),
        //    dragEnabled: false,
        //    hideOnOutsideClick: false,
        //    focusStateEnabled: false,
        //    shading: false,
        //    visible: false,
        //    titleTemplate: function (titleElement) {
        //        if (typeof option.backgroundcolortitle != 'undefined') titleElement.css("background-color", option.backgroundcolortitle)
        //        popup.titleElement = titleElement;
        //        titleElement.css("padding", "0 10px")
        //        var $Table = $("<table style='height:28px;'/>").appendTo(titleElement)
        //        var $Tr = $("<tr/>").appendTo($Table);
        //        var $Td = $("<td style='width:100%;vertical-align:middle;'>" + option.titre + "</td>").appendTo($Tr)
        //        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        //        if (typeof option.showCloseButton == 'undefined' || option.showCloseButton) {
        //            var bt = $("<div/>").appendTo($Td).dxCtrlButton({
        //                focusStateEnabled: false,
        //                icon: "fas fa-times",
        //                onClick: function () { popup.hide(); }
        //            });
        //        }
        //    },
        //    contentTemplate: function (contentElement) {
        //        if (typeof option.backgroundcolorcontent != 'undefined') contentElement.css("background-color", option.backgroundcolorcontent)
        //        popup.contentElement = contentElement;
        //        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
        //        var $Table = $("<table style='width:100%;vertical-align:top'>").appendTo(dxScroll.content())
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:1px;vertical-align:top;padding-right:10px;'>" + ((option.img) ? option.img : "") + "</td>").appendTo($Tr)
        //        var $Td = $("<td style='width:100%;vertical-align:middle'></td>").appendTo($Tr)
        //        //$("<table style='width:100%;vertical-align:top'><tr><td style='width:1px;vertical-align:middle;padding-right:5px;'>" + ((option.img) ? option.img : "") + "</td><td style='width:100%;vertical-align:middle'>" + option.message + "</td></tr></table>").appendTo(contentElement)
        //        if (typeof option.message === 'function') {
        //            option.message($Td, popup);
        //        }
        //        else {
        //            $Td.html(option.message)
        //        }
        //        var height = contentElement.innerHeight() + popup.titleElement.innerHeight()
        //        if (height > $("body").innerHeight()) height = $("body").innerHeight()
        //        popup.option("height", height);

        //        //window.setTimeout(function () {
        //        //    popup.hide();
        //        //}, option.tempoSeconde * 1000);
        //        var progressBar = $("<div/>").appendTo(contentElement).dxProgressBar({
        //            min: 0,
        //            max: option.tempoSeconde,
        //            value: option.tempoSeconde,
        //            showStatus: false
        //        })

        //        if (typeof option.tempoSeconde == 'undefined') {
        //            if ($.isFunction(option.message)) {
        //                option.tempoSeconde = 10
        //            } else {
        //                option.tempoSeconde = option.message.split(" ").length + option.message.split("<br/>").length / 3;
        //                if (option.tempoSeconde < 10) option.tempoSeconde = 10;
        //            }
        //        }
        //        var tempoEvol = option.tempoSeconde
        //        var intervalEvol = window.setInterval(function () {
        //            if (contentElement.closest("body").length == 0) window.clearInterval(intervalEvol)
        //            tempoEvol -= 50
        //            progressBar.option("value", tempoEvol)
        //            if (tempoEvol <= 0) {
        //                window.clearInterval(intervalEvol)
        //                popup.hide();
        //            }
        //        }, 50)

        //        window.setTimeout(function () {
        //            var height = contentElement.innerHeight() + popup.titleElement.innerHeight()
        //            if (height > $("body").innerHeight()) height = $("body").innerHeight()
        //            popup.option("height", height);
        //        }, 10);
        //    },
        //    onShowing: function (e) {
        //        if (typeof option.son != 'undefined' && option.son && option.son.length > 0 && option.bddCtrl.utiCourantParaJson.parametre_general.son_on) {
        //            try {
        //                switch (option.son) {
        //                    case "attention": $AUDIOAttention.play(); break;
        //                    case "erreur": $AUDIOErreur.play(); break;
        //                    case "email": $AUDIOEmail.play(); break;
        //                    case "info": $AUDIOInfo.play(); break; //vue
        //                    case "rappel": $AUDIORappel.play(); break;
        //                    case "tut": $AUDIOTut.play(); break;
        //                    case "flute": $AUDIOFlute.play(); break; //click
        //                    case "guitare": $AUDIOGuitare.play(); break; //sms recu
        //                    case "pop": $AUDIOPop.play(); break; //email recu
        //                }
        //            }
        //            catch (e) { }
        //        }
        //        //popup.option("height", popup.contentElement.innerHeight() + 25);
        //    },
        //    onShown: function (e) {
        //        //popup.option("height", popup.contentElement.innerHeight() + 25);
        //    },
        //    onHiding: function () {
        //        var Height = popup.option("height");
        //        var timeOutHide = null;
        //        if (lstPopup.length > 1) {
        //            for (var i = lstPopup.indexOf(popup) + 1; i < lstPopup.length; i++) {
        //                var popupAfter = lstPopup[i];
        //                popupAfter.offset += (Height + 5);
        //                lstPopup[i].element().find(".dx-popup-normal").animate({
        //                    top: Height + 5 + "px"
        //                })
        //                if (timeOutHide) window.clearTimeout(timeOutHide);
        //                timeOutHide = window.setTimeout(function () {
        //                    for (var j = lstPopup.indexOf(popup) + 1; j < lstPopup.length; j++) {
        //                        lstPopup[j].element().find(".dx-popup-normal").css("top", "0px");
        //                        lstPopup[j].option("position", {
        //                            at: 'right bottom',
        //                            my: 'right bottom',
        //                            of: window,
        //                            offset: "-10 " + lstPopup[j].offset
        //                        });
        //                    }
        //                }, 800);
        //            }
        //        }
        //    },
        //    onHidden: function () {
        //        lstPopup.splice(lstPopup.indexOf(popup), 1);
        //        popup.element().remove();
        //    }
        //}).dxPopup("instance");

        //var offset = -10
        //lstPopup.forEach(function (pop, i) { offset = offset - pop.option("height") - 5; });
        //popup.option("position", {
        //    at: 'right bottom',
        //    my: 'right bottom',
        //    of: window,
        //    offset: "-10 " + offset
        //});
        //popup.offset = offset;
        //popup.show();
        //indx += 1
        //popup.indx = indx;

        //popup.bringToFront = function () {
        //    popup._updateZIndexStackPosition(false);
        //    popup._updateZIndexStackPosition(true);
        //}

        //lstPopup.push(popup);
        //return popup;
    }

    this.mBringToFront = function () {
        lstPopup.forEach(function (pop) {
            pop._updateZIndexStackPosition(false);
            pop._updateZIndexStackPosition(true);
        });
    }
}
window.notify = new cDxNotify()

window.cMessagePopup = function () {
    var Me = this;

    var lstPopDiv = []
    var lstPopDivInShow = []

    this.mShow = function (option) {

        //if (!$AUDIOAttention) {
        //    $AUDIOAttention = $('<audio src="' + parametre.urldispatch + '/son/attention.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOEmail = $('<audio src="' + parametre.urldispatch + '/son/email.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOInfo = $('<audio src="' + parametre.urldispatch + '/son/information.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIORappel = $('<audio src="' + parametre.urldispatch + '/son/rappel.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOPop = $('<audio src="' + parametre.urldispatch + '/son/pop.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOTut = $('<audio src="' + parametre.urldispatch + '/son/tut.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOGuitare = $('<audio src="' + parametre.urldispatch + '/son/guitare.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //    $AUDIOFlute = $('<audio src="' + parametre.urldispatch + '/son/flute.mp3?v=' + parametre.version + '"/>').appendTo("body");
        //}

        var zIndex = mGetMaxZindex()
        var container = ((typeof $DivGeneral == 'undefined' || $DivGeneral == null) ? $("body") : $DivGeneral)
        var $Div = $("<div style='opacity:0;position:absolute;right:10px;bottom:0;width:" + ((typeof option.width == "undefined") ? 350 : option.width) + "px;padding:10px;background-color:" + theme.backgroundcolorTooltip + ";z-index:" + zIndex + 1 + ";box-shadow: 0px 0px 15px 2px rgba(0,0,0,0.9);' class='popupcontent'/>").appendTo(container)
        var $DivInterne = $("<div style='position:relative;height:100%;width:100%;'/>").appendTo($Div)
        if (typeof option.showCloseButton == 'undefined' || option.showCloseButton) {
            var $DivClose = $("<div class='state-hover' style='opacity:0;position:absolute;border-radius:50%;cursor:pointer;top:-20px;left:-15px;background-color:" + theme.backgroundcolorBase + ";'><i class='fas fa-times' style='font-size:160%;padding: 10px 14px;color:" + theme.backgroundcolorAccent + ";'></i></div>").appendTo($DivInterne)
            $Div.on("mouseenter", function (e) { $DivClose.css("opacity", 0.8) })
            $Div.on("mouseleave", function (e) { $DivClose.css("opacity", 0) })
            $DivClose.on("click", function (e) {
                e.stopPropagation()
                $Div.hide();
            })
        }

        $Div.hide = function () {
            window.clearTimeout(timeoutClose)
            mHide($Div, option)
        }
        var isIn = false
        $Div.hover(
            function () {
                // souris entre dans la div
                console.log("Entrée");
                isIn = true
            },
            function () {
                // souris quitte la div
                console.log("Sortie");
                isIn=false
            }
        );
        if (typeof option.backgroundcolorcontent != 'undefined') $Div.css("background-color", option.backgroundcolorcontent)
        var $Table = $("<table style='width:100%;vertical-align:top'>").appendTo($DivInterne)
        if (typeof option.titre != 'undefined') {
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;font-size:130%;font-weight:bold;' colspan='2'>" + option.titre + "</td>").appendTo($Tr)
        }
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;padding-right:10px;'>" + ((typeof option.img != 'undefined') ? option.img : ((typeof option.icone != 'undefined') ? option.icone : "")) + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;vertical-align:middle;word-break:break-word;'></td>").appendTo($Tr)
        if (typeof option.message === 'function') { option.message($Td, $Div); }
        else { $Td.html(option.message) }

        var $Table = $("<table/>").appendTo($DivInterne)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;cursor:pointer;' class='state-hover dx-theme-accent-as-text-color' title='Bloquer la fenêtre'><i class='fas fa-stop'></i></td>").appendTo($Tr)
        $Td.on("click", function (e) {
            $Table.remove();
            window.clearTimeout(timeoutClose)
            window.clearInterval(intervalEvol);
        })
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var progressBar = $("<div/>").appendTo($Td).dxProgressBar({
            min: 0,
            max: option.tempoSeconde * 1000,
            value: 0,
            showStatus: false
        }).dxProgressBar("instance")

        if (typeof option.tempoSeconde == 'undefined') {
            if ($.isFunction(option.message)) {
                option.tempoSeconde = 10
            } else {
                option.tempoSeconde = option.message.split(" ").length + option.message.split("<br/>").length / 3;
                if (option.tempoSeconde < 10) option.tempoSeconde = 10;
            }
        }


        lstPopDivInShow.push($Div)
        var timeoutClose = null
        var intervalEvol = null
        window.setTimeout(function () {
            $Div.css("bottom", $Div.innerHeight() + "px")
            mShow($Div, option);

            if (option.tempoSeconde > 1000) {
                timeoutClose = window.setTimeout(function () { $Div.hide(); }, option.tempoSeconde * 1000);
            } else {
                var tempoEvol = 0
                intervalEvol = window.setInterval(function () {
                    if (isIn) return
                    if ($Div.closest("body").length == 0) window.clearInterval(intervalEvol)
                    tempoEvol += 50
                    progressBar.option("value", tempoEvol)
                    if (tempoEvol >= option.tempoSeconde * 1000) {
                        window.clearInterval(intervalEvol)
                        $Div.hide();
                    }
                }, 50)
            }
        }, 0)

        return $Div
    }

    this.msAnim = 400
    function mShow($Div, option) {
        if (lstPopDivInShow.indexOf($Div) > 0) {
            window.setTimeout(function () { mShow($Div, option) }, 50);
            return;
        }
        var height = $Div.innerHeight()
        lstPopDiv.forEach(function (popDiv) {
            if (popDiv != $Div) {
                var bottom = parseInt(popDiv.css("bottom").replace("px", "")) + height + 23
                popDiv.animate({ bottom: bottom + "px" }, Me.msAnim)
            }
        })
        $Div.css({
            transition: "transform 0ms ease-out, opacity 0ms ease-out",
            transform: "translate(0, " + (2 * $Div.innerHeight() - 10) + "px) scale(0)",
            opacity: 0
        })
        $Div.css({
            transition: "transform " + Me.msAnim + "ms ease-out, opacity " + Me.msAnim + "ms ease-out",
            transform: "translate(0, " + ($Div.innerHeight() - 10) + "px)",
            opacity: 1
        })
        if (typeof option.son != 'undefined' && option.son && option.son.length > 0 && option.bddCtrl.utiCourantParaJson.parametre_general.son_on) {
            window.setTimeout(function () {
                try {
                    var ok = true
                    switch (option.son) {
                        case "attention": $AUDIOAttention.play(); break;
                        case "erreur": $AUDIOErreur.play(); break;
                        case "email": $AUDIOEmail.play(); break;
                        case "info": $AUDIOInfo.play(); break;
                        case "rappel": $AUDIORappel.play(); break;
                        case "tut": $AUDIOTut.play(); break;
                        case "flute": $AUDIOFlute.play(); break;
                        case "guitare": $AUDIOGuitare.play(); break;
                        case "pop": $AUDIOPop.play(); break;
                        default: ok = false;
                    }
                    //if (ok) {
                    //    var txt = ""
                    //    if (typeof option.titre != 'undefined') {
                    //        txt = option.titre + "\n"
                    //    }
                    //    const tmp = document.createElement("div");
                    //    if (typeof option.message === 'function') {
                    //        option.message($(tmp), null);
                    //    } else {
                    //        tmp.innerHTML = option.message;
                    //    }
                    //    txt += tmp.textContent || tmp.innerText || "";
                    //    if (Notification.permission === "granted") {
                    //        // L’utilisateur a déjà accepté : on peut afficher une notif immédiatement
                    //        new Notification(txt);
                    //    } else if (Notification.permission !== "denied") {
                    //        // L’utilisateur n’a pas encore choisi : on demande l’autorisation
                    //        Notification.requestPermission().then(permission => {
                    //            if (permission === "granted") {
                    //                new Notification(txt);
                    //            }
                    //        });
                    //    }
                    //}
                }
                catch (e) { }
            }, Me.msAnim)
        }
        window.setTimeout(function () {
            lstPopDivInShow.splice(lstPopDivInShow.indexOf($Div), 1)
            lstPopDiv.push($Div)
        }, Me.msAnim + 50)
    }

    function mHide($Div, option) {
        var height = $Div.innerHeight()
        lstPopDiv.forEach(function (popDiv, idx) {
            if (idx < lstPopDiv.indexOf($Div)) {
                var bottom = parseInt(popDiv.css("bottom").replace("px", "")) - height - 23
                popDiv.animate({ bottom: bottom + "px" }, Me.msAnim)
            }
        })
        $Div.css({
            transition: "transform " + Me.msAnim + "ms ease-out, opacity " + Me.msAnim + "ms ease-out",
            transform: "translate(0, " + (2 * $Div.innerHeight() - 10) + "px) scale(0)",
            opacity: 0
        })
        window.setTimeout(function () {
            $Div.remove();
            //Me.mShow(option)
        }, Me.msAnim)
    }
}
window.messagePopup = new cMessagePopup()

window.mShowPopupOkAnnuler = function (title, contentTemplate, onOk, onAnnuler, textOk, textAnnuler) {
    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupBase({
        title: title,
        width: 600,
        height: 'auto',
        showMaximize: false,
        contentTemplate: function (contentElement) {
            contentElement.css("padding", "20px 20px 5px 20px")
            contentTemplate(contentElement)
            var $Table = $("<table style='width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table);
            $("<td style='width:100%'/>").appendTo($Tr)
            if (typeof onOk != 'undefined' && onOk != null) {
                var $Td = $("<td style='width:1px;padding-right:5px'/>").appendTo($Tr)
                var btOk = $("<div/>").appendTo($Td).dxCtrlButton({
                    text: ((typeof textOk == 'undefined') ? "Ok" : textOk),
                    focusStateEnabled: false,
                    onClick: function (e) { onOk(); pop.hide(); }
                }).dxCtrlButton("instance");
            }
            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
            if (typeof onAnnuler != 'undefined' && onAnnuler != null) {
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: ((typeof textAnnuler == 'undefined') ? "Annuler" : textAnnuler),
                    focusStateEnabled: false,
                    onClick: function (e) {
                        if (typeof onAnnuler != 'undefined' && onAnnuler != null) onAnnuler()
                        pop.hide();
                    }
                });
            }
        },
        onHiding: function (e) { }
    }).dxCtrlPopupBase("instance")
    pop.show();
}